function getTreeParentHeaderAlert(page: any) {
    if (!page || !page.treeParent) {
        return null;
    } else if (page.treeParent.headerAlert) {
        return page.treeParent.headerAlert;
    } else if (page.treeParent) {
        return getTreeParentHeaderAlert(page.treeParent);
    }

    return null;
}

export function getHeaderAlert(page: any) {
    if (page && page.headerAlert) {
        return page.headerAlert;
    }

    return getTreeParentHeaderAlert(page);
}

const addLink = (links: any, item: any) => {
    links.unshift({
        href: item?.slug,
        title: item?.title,
    });

    return links;
};

const addParentLink = (links: any, treeParent: any) => {
    links = addLink(links, treeParent);

    if (treeParent.treeParent) {
        links = addLink(links, treeParent.treeParent);
    }

    return links;
};

export function getBreadcrumbLinks(home: any, page: any) {
    let links = [
        {
            title: page.title,
        },
    ];

    if (page.treeParent) {
        links = addParentLink(links, page.treeParent);
    }

    if (home) {
        links = addLink(links, home);
    }

    return links;
}

export function getSharingLinks(url: string, title: string) {
    return [
        {
            url: `https://x.com/intent/tweet?url=${encodeURI(
                url,
            )}&text=${encodeURI(title)}`,
            icon: 'twitter',
        },
        {
            url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(
                url,
            )}&title=${encodeURI(title)}`,
            icon: 'linkedin',
        },
    ];
}
